module.exports = __webpack_public_path__ + "img/shine.ba38a9b5.png";